module.exports = __webpack_public_path__ + "img/43_48.cab87fe6.png";